module.exports = __webpack_public_path__ + "img/service_2.8b08e686.jpg";